import { render } from "./Quotations.vue?vue&type=template&id=351cd9b0"
import script from "./Quotations.vue?vue&type=script&lang=js"
export * from "./Quotations.vue?vue&type=script&lang=js"
script.render = render

export default script